export const localStorageKeys = {
  actions: '__actions',
  saleman: '__saleman',
  distributor: 'distributor',
  session: 'dist_session',
  permissions: 'permissions',
};
